const orderingData = {
  name: 'ordering',
  titleText: '¿Te llegó un pedido y no tienes capital?',
  subtitleText: 'Con Ordering de Fingo financiamos tus órdenes de compra para que no pierdas ninguna venta. '
  + 'Recibe el pedido, nosotros te ayudamos a cumplirlo.',
  startTextButton: 'Anticipar Órdenes de compra',
  hero_image: '/images/ordering_herov2.webp',
  description_information: {
    image: '/images/ordering_description.webp',
    title: '¿Qué es el Ordering?',
    text: 'Ordering es una solución de financiamiento que permite a las empresas acceder a capital utilizando como respaldo una Orden de Compra (OC) emitida por su cliente. '
    + 'Esto les da la posibilidad de adelantar dinero, para así iniciar o continuar con sus proyectos sin tener que esperar hasta la entrega del producto o servicio. '
    + 'En Fingo, las facturas que se emiten posteriormente como resultado de esa OC son las que se utilizan para devolver el financiamiento entregado.',
  },
  benefits_information: {
    image: '/images/ordering_benefits.webp',
    title: 'Beneficios de financiar tus OC en Fingo',
    text: [
      'Proceso ágil, 100% digital, con acompañamiento personalizado y sin papeleo innecesario.',
      'Comienza tus proyectos sin necesidad de capital propio ni afectar tu flujo de caja.',
      'Las facturas emitidas posteriormente se utilizan automáticamente para devolver el financiamiento.',
      'Fortalece tu cumplimiento con clientes al contar con los recursos necesarios desde el inicio.',
    ],
  },
  requirements_information: {
    image: '/images/solution_requirements.webp',
    title: 'Requisitos',
    text: [
      'Tener una empresa con al menos 2 años de antigüedad (conversable según el caso).',
      'No presentar registros negativos en DICOM ni deudas con la Tesorería General de la República (TGR).',
      'Presentar los balances de los dos últimos períodos de caja.',
      'Contar con la Orden de Compra (OC) en formato PDF.',
    ],
  },
};

export default orderingData;
